import { createRoot } from 'react-dom/client'
import { captureConsoleIntegration, init as initSentry } from '@chilipiper/sentry'
import { environment, sentry } from '@chilipiper/config'
import { init as initWebsocketDebugger } from '@chilipiper/websocket-debugger'
import { rolloutInit } from '@chilipiper/rollout'
import React from 'react'
import { App } from './App'
import { getTenantId, sendMessageToEmbed } from './utils/embedCommunication'
import '@chilipiper/design-system/css/reset.css'

window.addEventListener('error', errorEvent => {
  sendMessageToEmbed({ type: 'ERROR', value: errorEvent.error })
})

initWebsocketDebugger()

initSentry(sentry.chatWidget, {
  tracesSampleRate: 0.01,
  replaysOnErrorSampleRate: 0.1,
  enabled: environment.deploy !== 'staging' && environment.node !== 'test',
  replaysSessionSampleRate: 0.0001,
  initialScope: scope => {
    scope.setTags({ appVersion: process.env.SENTRY_RELEASE_COMMIT })
    return scope
  },
  integrations: [captureConsoleIntegration({ levels: ['error'] })],
  attachStacktrace: true,
})

const root = document.getElementById('root')
if (!root) {
  console.error("Couldn't find the root to mount the widget")
} else {
  rolloutInit('chili-chat')
    .then(setUserData => {
      setUserData({ tenantId: getTenantId() })
      createRoot(root).render(<App />)
    })
    .catch(error => {
      console.error('Failed to initialize the widget', error)
    })
}
